import { SegmentedControl, Stack } from "@mantine/core";
import { type ReactNode, useState } from "react";
import MetadataDocuments from "../MetadataDocuments";
import { ExpandGraph } from "./ExpandGraph";
import type { BucketSelection, DocumentViewsProps } from "./types";
import { DocumentViewMode } from "./types";

const VIEW_OPTIONS = [
    { value: DocumentViewMode.TABLE, label: "Table" },
    { value: DocumentViewMode.EXPLODE, label: "Overview" },
];

export const DocumentViews = ({ index, rootLabel, onFilteredCountChange }: DocumentViewsProps) => {
    const [mode, setMode] = useState<DocumentViewMode>(DocumentViewMode.TABLE);
    const [initialFilter, setInitialFilter] = useState<BucketSelection[]>();
    const [tableKey, setTableKey] = useState(0);

    const openFiltered = (selection: BucketSelection[]) => {
        setInitialFilter(selection);
        setTableKey((current) => current + 1);
        setMode(DocumentViewMode.TABLE);
    };

    const content: Record<DocumentViewMode, () => ReactNode> = {
        [DocumentViewMode.TABLE]: () => (
            <MetadataDocuments
                key={`${index}-${tableKey}`}
                index={index}
                initialFilter={initialFilter}
                onFilteredCountChange={onFilteredCountChange}
            />
        ),
        [DocumentViewMode.EXPLODE]: () => (
            <ExpandGraph index={index} rootLabel={rootLabel} onOpen={openFiltered} />
        ),
    };

    return (
        <Stack gap="md">
            <SegmentedControl
                data={VIEW_OPTIONS}
                value={mode}
                onChange={(value) => setMode(value as DocumentViewMode)}
                w="fit-content"
            />
            {content[mode]()}
        </Stack>
    );
};
